import { Box, Chip, Typography } from "@mui/material";
import { getLabellingMaterialDisplayName } from "components/scrapEyeLabelling/utils/materialDisplayName";
import { useTenantTranslation } from "hooks/formatters";
import { useMaterialColor } from "hooks/useMaterials";
import { MaterialRead } from "src/store/api/generatedApi";
import { KeyIndicator } from "./KeyIndicator";

export const MaterialChip = ({
  material,
  selected,
  onClick,
  shortcut,
  nullLabel,
  isCoMaterial = false,
}: {
  material: MaterialRead | null;
  selected: boolean;
  onClick: () => void;
  shortcut?: string | null;
  nullLabel?: string;
  isCoMaterial?: boolean;
}) => {
  const { t } = useTenantTranslation();
  const { getColor } = useMaterialColor();
  const color = getColor(material?.name ?? "");
  const materialDisplayName = (
    material
      ? getLabellingMaterialDisplayName(material, t)
      : (nullLabel ?? t("unknown"))
  ).toUpperCase();

  return (
    <Chip
      label={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: selected ? 600 : 400,
              color: selected ? "white" : "black",
            }}
          >
            {materialDisplayName}
          </Typography>
          {shortcut ? (
            <KeyIndicator
              keyLabel={shortcut}
              variant={selected ? "dark" : "light"}
            />
          ) : null}
        </Box>
      }
      onClick={onClick}
      sx={{
        backgroundColor: selected ? color : `${color}40`,
        ...(isCoMaterial && {
          backgroundImage: `repeating-linear-gradient(45deg, transparent 0 6px, ${color}66 6px 12px)`,
        }),
        borderColor: color,
        borderWidth: 2,
        borderStyle: "solid",
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:focus": {
          outline: "2px solid",
          outlineColor: "primary.main",
          outlineOffset: "2px",
          boxShadow: `0 0 0 4px ${color}40`,
        },
        "&:hover": {
          backgroundColor: selected ? color : `${color}80`,
          boxShadow: `0 2px 8px ${color}60`,
        },
      }}
    />
  );
};
